import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useLang } from "@/i18n";

export const LegalDialog = ({ type }) => {
  const { t } = useLang();
  const label = type === "impressum" ? t.legal.impressumLabel : t.legal.datenschutzLabel;
  const title = type === "impressum" ? t.legal.impressumTitle : t.legal.datenschutzTitle;
  const body = type === "impressum" ? t.legal.impressumBody : t.legal.datenschutzBody;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          data-testid={`legal-${type}`}
          className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-[var(--txt-mut)] hover:text-[var(--txt)] transition-colors duration-300 link-underline"
        >
          {label}
        </button>
      </DialogTrigger>
      <DialogContent
        data-testid={`legal-dialog-${type}`}
        className="max-w-2xl bg-[var(--bg-1)] border border-[var(--line)] text-[var(--txt)] max-h-[85vh] overflow-y-auto"
      >
        <DialogHeader>
          <DialogTitle className="font-heading font-bold text-2xl md:text-3xl tracking-tight text-[var(--txt)]">
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-5 mt-2">
          {body.map((item, i) =>
            typeof item === "string" ? (
              <p
                key={i}
                className="font-body font-light text-sm md:text-[15px] leading-relaxed text-[var(--txt-dim)]"
              >
                {item}
              </p>
            ) : (
              <div key={i}>
                <h4 className="font-heading font-bold text-[var(--txt)] text-sm md:text-base tracking-tight mb-1.5">
                  {item.t}
                </h4>
                <p className="font-body font-light text-sm md:text-[15px] leading-relaxed text-[var(--txt-dim)]">
                  {item.d}
                </p>
              </div>
            )
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
